"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.label = void 0;
const tv_1 = require("../utils/tv");
exports.label = (0, tv_1.tv)({
  base: `
    text-neutral
    peer-[[data-hover]]:cursor-pointer
    peer-[[data-disabled]]:text-neutral-disabled
  `,
  variants: {
    size: {
      small: `text-sm leading-sm`,
      medium: `text-md leading-md`
    }
  },
  defaultVariants: {
    size: 'medium'
  }
});
